import { DWEB_MAX_WIDTH } from 'shared/styles/base';

export const CAROUSEL_NAV_PADDING = 30;

export const DESKTOP_CAROUSEL_PROPS = {
  slideWidth: 258,
  slideHeight: 503,
  slidesToMove: 2,
  slidesToShow: 4,
} as const;

export const DESKTOP_CAROUSEL_SLIDE_MARGIN =
  (DWEB_MAX_WIDTH -
    CAROUSEL_NAV_PADDING * 2 -
    DESKTOP_CAROUSEL_PROPS.slidesToShow * DESKTOP_CAROUSEL_PROPS.slideWidth) /
  (DESKTOP_CAROUSEL_PROPS.slidesToShow - 1);

export const getCarouselProps = (width: number) => {
  switch (true) {
    case width < 1110: {
      return {
        slideWidth: 278,
        slideHeight: 543,
        slidesToMove: 1,
        slidesToShow: 3,
      };
    }

    case width < 1150: {
      return {
        slideWidth: 228,
        slideHeight: 523,
        slidesToMove: 2,
        slidesToShow: 4,
      };
    }

    case width < 1200: {
      return {
        slideWidth: 238,
        slideHeight: 523,
        slidesToMove: 2,
        slidesToShow: 4,
      };
    }

    default: {
      return { ...DESKTOP_CAROUSEL_PROPS };
    }
  }
};

export const getCAVCarouselProps = (width: number) => {
  switch (true) {
    case width < 1110: {
      return {
        slideWidth: 228,
        slideHeight: 264,
        slidesToMove: 1,
        slidesToShow: 3,
      };
    }

    case width < 1150: {
      return {
        slideWidth: 228,
        slideHeight: 264,
        slidesToMove: 2,
        slidesToShow: 4,
      };
    }

    case width < 1200: {
      return {
        slideWidth: 238,
        slideHeight: 276,
        slidesToMove: 2,
        slidesToShow: 4,
      };
    }

    default: {
      return {
        slideWidth: 250,
        slideHeight: 296,
        slidesToMove: 2,
        slidesToShow: 4,
        margin: 24,
        padding: 0,
        imageGutter: 8,
      };
    }
  }
};
